<ng-container *ngComponentOutlet="component(); inputs: componentInputs()" />
@if (!notification().read) {
    <button
        class="absolute top-0 right-0 size-12 shrink-0 rounded-full bg-surface-primary"
        type="button"
        [attr.aria-label]="'SHARED.NOTIFICATIONS.MARK_AS_READ' | translate"
        [matTooltip]="'SHARED.NOTIFICATIONS.MARK_AS_READ' | translate"
        (click)="$event.stopPropagation(); markAsRead.emit()"
    ></button>
}
